import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'unistore/react';
import classnames from 'classnames';

import { summedupDataSelector } from '~/scripts/state/selectors';
import actions from '~/scripts/state/actions';
import PartyBars from '~/scripts/PartyBars';
import RankingList from '~/scripts/RankingList';
import RankingListExpandButton from '~/scripts/RankingList/ExpandButton';

class OverallResult extends PureComponent {
  static propTypes = {
    isCompact: PropTypes.bool
  }

  static defaultProps = {
    isCompact: false
  }

  state = {
    isExpanded: false
  }

  componentDidMount() {
    const wrapper = document.querySelector('.electionmap-wrapper');

    this.wrapperBounds = wrapper.getBoundingClientRect();
    this.maxHeight = this.props.isCompact ? 'none' : `${(this.wrapperBounds.height * 0.9) - 80}px`;
  }

  onToggleExpand() {
    this.setState(prevState => ({ isExpanded: !prevState.isExpanded }));
  }

  render() {
    const { isCompact } = this.props;
    const { isExpanded } = this.state;
    const showRanking = isExpanded && !isCompact;
    const wrapperClasses = classnames('overallresult', { 'is-compact': isCompact });

    return (
      <div className={wrapperClasses}>
        <div className="overallresult__inner" style={{ maxHeight: this.maxHeight }}>
          <div className="overallresult__title">So hat {baseconfig.app.areaName} gewählt</div>
          <div className="overallresult__subtitle">Parteistimmen</div>
          <PartyBars
            items={this.props.data}
            onClick={this.props.setParty}
            isClickable
            selectedParty={this.props.selectedParty}
            scaleToMax
          />
          <div className="overallresult__explainer">Partei wählen für alle <strong>Ergebnisse</strong> und <strong>Hochburgen</strong> dieser Partei</div>
          {!isCompact && (
            <RankingListExpandButton
              isExpanded={this.state.isExpanded}
              onClick={() => this.onToggleExpand()}
            />
          )}
          {showRanking && (
            <RankingList
              data={this.props.data}
              onClickItem={this.props.setParty}
              selectedParty={this.props.selectedParty}
              isClickable
            />
          )}
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  data: summedupDataSelector(state),
  selectedParty: state.selectedParty,
}), actions)(OverallResult);
